import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/pro-solid-svg-icons/faImage';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import style from './item-image.module.less';

const renderImage = (src, alt) => (
  <div className={style['item-image']}>
    <img alt={alt} className={style.image} src={src} />
  </div>
);

const renderPlaceholder = () => {
  const classes = classnames(style.image, style.placeholder);
  return (
    <div className={style['item-image']}>
      <div className={classes}>
        <FontAwesomeIcon icon={faImage} />
      </div>
    </div>
  );
};

export const ItemImage = ({ src, alt = 'Item Thumbnail' }) => {
  return src ? renderImage(src, alt) : renderPlaceholder();
};

ItemImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
};
